var _classCallCheck = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/helpers/createClass.js");

var Messenger = /*#__PURE__*/function () {
  "use strict";

  /**
   * @callback onMessage
   * @param {error} err
   * @param {Object} result
   */

  /**
   * @description Callback function to send response to the window source of the message
   * @callback sendResponse
   * @param {Object} response Message response
   * @returns {void}
   */

  /**
   * @description Callback function to manage message received from the channel
      * @callback onMessageCallback
      * @param {Object} json
   * @param {Window} source
      * @param {sendResponse} cb
   * @param {Messenger} bridge
   * @returns {void}
      */

  /**
   * @description Send message options
   * @typedef {Object} sendMessageOptions
   * @property {boolean} waitForReply Wait for a reply from the recipient
   * @property {string} origin Override Window.origin
   * @property {number} timeout Timeout to wait for reply message, default 4000 msec
   */

  /**
      * @param {string} channelName  Channel Name
      * @param {onMessageCallback} [onMessageCallback] Callback function
      */
  function Messenger(channelName, onMessageCallback) {
    _classCallCheck(this, Messenger);

    this.channelName = channelName;
    this.onMessage = onMessageCallback;

    this._installListener();
    /**
     * @access private
     * @typedef {Object.<string, onMessage>} RequestObject Request objects
     * @type {RequestObject} _requests Mapping of request ids to callbacks
     */


    this._requests = new Map();
    /**
     * @access private
     * @type {number} Next request id
     */

    this._nextId = 0;
    /**
     * @access private
     * @type {number} Time to wait for the message response
     */

    this._defaultTimeout = 4000;
  }
  /**
   * @access private
   */


  _createClass(Messenger, [{
    key: "_installListener",
    value: function _installListener() {
      var that = this;
      /**
       * @access private
       * @param {Window} this
       * @param {MessageEvent} event
       */

      this._listener = function (event) {
        // Ignore invalid messages or those after the client has closed
        if (!event.data || typeof event.data !== 'string') {
          return;
        }

        var json;

        try {
          json = JSON.parse(event.data);

          if (!json.channel || json.channel !== that.channelName) {
            return;
          }

          if (typeof json.message !== 'object') {
            return;
          }
        } catch (err) {
          // Ignore malformed messages or not targetting us
          return;
        } // Add request callback


        if (typeof json.replyId !== 'undefined') {
          if (typeof json.replyId !== 'number' || json.replyId % 1 !== 0) {
            return;
          } // If we have a message waiting for a reply, process it, else ignore


          var req = that._requests.get(json.replyId);

          if (req) {
            clearTimeout(req.timeout);

            that._requests.delete(json.replyId);

            req.resolve(json.message);
          }
        } else {
          if (typeof json.id !== 'number' || json.id % 1 !== 0 || !that.onMessage) {
            return;
          } // We received a message


          var channel = that.channelName;
          var replyId = json.id;
          var origin = event.origin;

          var replyMessage = function replyMessage(message) {
            var request = {
              channel: channel,
              replyId: replyId,
              message: message
            };
            event.source.postMessage(JSON.stringify(request), origin);
          };

          that.onMessage(json.message, event.origin, event.source, replyMessage, that);
        }
      };

      window.addEventListener("message", this._listener);
    }
    /**
     * @access public
     * @description Send a message to another window
     * @param {Window} targetWindow Target Window
     * @param {Object} message Object Message
     * @param {string} origin Target origin
     * @param {sendMessageOptions} [options] Object Message
     * @returns {Promise<any>} Returns
     */

  }, {
    key: "sendMessage",
    value: function sendMessage(targetWindow, message, origin, options) {
      // Prepare message
      var request = {
        channel: this.channelName,
        id: this.getNextId(),
        message: message
      };

      if (options && options.waitForReply) {
        var that = this;
        return new Promise(function (resolve, reject) {
          // Set a timeout if a response is not received
          var timeout = setTimeout(function () {
            var req = that._requests.get(request.id);

            if (req) {
              that._requests.delete(request.id);

              reject(new Error('Timeout expired for the message response'));
            }
          }, options && options.timeout ? options.timeout : that._defaultTimeout);

          that._requests.set(request.id, {
            timeout: timeout,
            resolve: resolve
          });

          targetWindow.postMessage(JSON.stringify(request), origin);
        });
      }

      targetWindow.postMessage(JSON.stringify(request), origin);
    }
    /**
     * @access public
     * @description Close client connection
     */

  }, {
    key: "close",
    value: function close() {
      window.removeEventListener('message', this._listener);
      this._listener = null;
      delete this._requests;
    }
    /**
     * @access private
     */

  }, {
    key: "getNextId",
    value: function getNextId() {
      this._nextId += 1;
      return this._nextId;
    }
  }]);

  return Messenger;
}();

module.exports = Messenger;